import React from 'react';

import StationMapCore from './StationMapCore';

import styles from './StationMap.scss';

import type { StationMapCoreProps } from './StationMapCore';

function StationMap(props: StationMapCoreProps) {
    return (
        <div className={styles.container}>
            <StationMapCore {...props} />
        </div>
    );
}

export default React.memo(StationMap);
